// frontend/src/features/avaliacao/services/avaliacaoAPI.ts
import api from '../../../services/apiConfig';

export interface EtapaInfo {
    id: number;
    etapa: number;
    status: 'aguardando' | 'disponivel' | 'respondida';
    data_recebimento: string | null;
    data_abertura_janela: string | null;
    data_fechamento_janela: string | null;
    respondida_em: string | null;
}

export interface VereditoInfo {
    veredito: 'aprovado' | 'reprovado';
    negociacao_preco: 'sim' | 'nao' | null;
    canal_venda: string | null;
    nome_revenda: string | null;
}

export interface EtapasResponse {
    etapas: EtapaInfo[];
    veredito: VereditoInfo | null;
}

export interface EtapaRespostasResponse {
    etapa: EtapaInfo;
    respostas: Record<string, any>;
}

/** Busca status de todas as etapas + veredito */
export const fetchEtapasStatus = async (pedidoId: number): Promise<EtapasResponse> => {
    const res = await api.get(`/avaliacao-etapas/${pedidoId}`);
    return res.data;
};

/** Busca respostas de uma etapa específica */
export const fetchEtapaRespostas = async (pedidoId: number, etapa: number): Promise<EtapaRespostasResponse> => {
    const res = await api.get(`/avaliacao-etapas/${pedidoId}/etapa/${etapa}`);
    return res.data;
};

/** Salva respostas de uma etapa */
export const saveEtapaRespostas = async (
    pedidoId: number,
    etapa: number,
    respostas: Record<string, any>
): Promise<void> => {
    await api.post(`/avaliacao-etapas/${pedidoId}/etapa/${etapa}`, { respostas });
};

/** Salva veredito final */
export const saveVeredito = async (
    pedidoId: number,
    veredito: VereditoInfo
) => {
    return api.post<{ success: boolean; message: string }>(`/avaliacao-etapas/${pedidoId}/veredito`, veredito);
};

/** Admin: liberar ou postergar etapa */
export const adminGerenciarEtapa = async (
    pedidoId: number,
    etapa: number,
    action: 'liberar' | 'postergar',
    dias?: number
): Promise<{ success: boolean; message: string }> => {
    const res = await api.put(`/avaliacao-etapas/${pedidoId}/etapa/${etapa}/admin`, { action, dias });
    return res.data;
};
